import { BaseModel } from '/@/modules/core/app/models/abstracts/BaseModel';

export class Step293616Meta extends BaseModel {
  /**
   * @deprecated
   * @var {boolean}
   */
  hasUnknownFather;

  /**
   * @deprecated
   * @var {boolean}
   */
  hasUnknownMother;

  /**
   * @var {?boolean}
   */
  isPlannerPermanentResidentOfCountry;

  constructor(model = {}) {
    super();
    this.hasUnknownFather = model.hasUnknownFather ?? true;
    this.hasUnknownMother = model.hasUnknownMother ?? true;
    this.isPlannerPermanentResidentOfCountry = model.isPlannerPermanentResidentOfCountry ?? null;
  }
}
